import { useCallback } from "react";

export function useFileEncoder() {
    const fileToBase64 = useCallback((file: File): Promise<string> => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result as string);
            reader.onerror = () => reject(new Error("Failed to encode file"));
            reader.readAsDataURL(file);
        });
    }, []);

    type EncodeFiles = {
        (file: File): Promise<string>;
        (files: File[]): Promise<string[]>;
    };

    const encodeFiles = useCallback(
        async (files: File | File[]): Promise<string | string[]> => {
            const results = await Promise.all(
                Array.isArray(files)
                    ? files.map(fileToBase64)
                    : [fileToBase64(files)]
            );
            return Array.isArray(files) ? results : results[0];
        },
        [fileToBase64]
    ) as EncodeFiles;

    return { fileToBase64, encodeFiles };
}
